export const firebaseErrorHandle = (error) => {
  // Firebase: Error (auth/wrong-password).
  let splitErr = error.split("Firebase: Error ");
  return splitErr[1];
};
